import projectListEmptyStateIllustration from "../../assets/images/projectListEmptyStateIllustration.webp";
import useTranslation from "../../hooks/useTranslation";

import style from "./ProjectPromo.module.css";

export const ProjectPromo = () => {
  const { t, m } = useTranslation();
  return (
    <div className={style.pageContainer}>
      <div className={style.promoContainer}>
        <img
          src={projectListEmptyStateIllustration}
          alt={t(m.General.NoSharedProjectsIllustrationAlt)}
          className={style.illustration}
        />
        <div className={style.title}>{t(m.General.NoSharedProjectsYet)}</div>
        <div className={style.subtitle}>{t(m.General.NoSharedProjectsDescription)}</div>
      </div>
    </div>
  );
};
